(function ($, undefined) {
	'use strict';

	let utils;
	let overlay;

	/**
	 * Creates or updates the gendata for the location
	 * */
	function createOrUpdateLocation(keys, values, callback) {
		keys.push('field1');
		values.push('location');
		// console.log(keys.indexOf('id'));
		// console.log(values[keys.indexOf('id')].length);

		if (keys.indexOf('id') === -1 || (values[keys.indexOf('id')] != undefined && values[keys.indexOf('id')].length === 0)) {
			enableSecondaryMenuItems();
			if (locationIsCompleted(undefined, makeObjectFromKeysAndValues(keys, values))) {
				keys.push("field13");
				values.push("true");
			}
			else {
				keys.push("field13");
				values.push("false");
			}
			createLocation(keys, values, callback);
		} else {
			utils.fetchGenDatas({ id: values[keys.indexOf('id')] }, gendatas => {
				if (gendatas.length) {
					enableSecondaryMenuItems();
					const gendata = gendatas[0];
					if (locationIsCompleted(gendata, makeObjectFromKeysAndValues(keys, values))) {
						keys.push("field13");
						values.push("true");
					}
					else {
						keys.push("field13");
						values.push("false");
					}
				}
				else {
					keys.push("field13");
					values.push("false");
				}
				updateLocation(keys, values, callback);
			});
		}
	}

	function parseInfo() {
		return $('.add-location-info__block:not(.add-location-info__block_template)').map((i, el) => {
			const info = {}
			const title = el.querySelector('.updated-select-input');
			let type = $(title).find(':selected').text();

			var container = $('.add-location-info-block__text-ctn', el).hasClass('add-location-info-block__text-ctn_hide') ?
				$('.add-location-info-block__input-ctn', el) :
				$('.add-location-info-block__text-ctn', el);
			var name = $('[name=name]', container)[0];
			var description = $('[name=description]', container)[0];
			try {
				info.description = tinymce.get("" + description.id).getContent();
			} catch (ex) {
				type = name.value; // override the type if it is Email or Phone with the custom label
				info.description = description.value;
				if (title.value == "email") {
					info.description = $(`<p><a href="mailto:${description.value}">${description.value}</a></p>`)[0].outerHTML;
				}
				if (title.value == "phone") {
					info.description = $(`<p><a href="tel:${description.value}">${description.value}</a></p>`)[0].outerHTML;
				}
			}

			info.title = title.value;
			info.type = type;
			return info;
		}).get();
	};

	function enableSecondaryMenuItems() {
		$('.side-menu .side-menu__item_disabled').removeClass("side-menu__item_disabled");
	}

	function makeObjectFromKeysAndValues(keys, values) {
		var obj = {};
		keys.forEach((key, index) => {
			obj[key] = values[index];
		});
		return obj;
	}

	function locationIsCompleted(locationGenData, newValues = {}) {
		if (!locationGenData && !$.isEmptyObject(newValues)) { return false; }
		var completed = true;
		var requiredFields = ["field1", "field2", "field4", "field5", "field6", "field7", "field8", "field9", "field10", "field11", "field14", "field15", "field16"];
		requiredFields.forEach((field) => {
			if ((locationGenData[field] == null || locationGenData[field].length === 0) && (!newValues[field] || newValues[field].length === 0)) {
				completed = false;
			}
		});
		return completed;
	}

	function updateLocation(keys, values, callback) {
		utils.updateGenDataFields(null, keys, values, (res) => {
			updateLocationCallback(res, callback);
		});
	}

	function updateLocationCallback(res, callback) {
		let id = null;

		if (res.indexOf("success-") > -1) {
			id = res.trim().split('success-')[1];
			utils.addOrReplaceParam('gid', id);

			$('.side-menu a').each((i, el) => {
				el.href = utils.addOrReplaceParam('gid', id, false, el.href);
			});

			utils.getPerson((person) => {
				updatePersonLocation(id, person, callback);
			});

		} else {
			callback(id);
		}
	}

	function createLocation(fields, values, callback) {
		var params = {
			ajax: true,
			field12: false,
			field19: true,
		};
		for (let i = 0; i < fields.length; i++) {
			params[fields[i]] = values[i];
		}

		$.ajax({
			url: '/action/sbNewLocation',
			data: params,
			method: 'POST',
			complete: function (response) {
				if (response.responseText.indexOf('fail') === -1) {
					updateLocationCallback(response.responseText, callback);
				}
			}
		});
	}

	function updatePersonLocation(id, person, callback) {
		const data = {
			ajax: true,
			field3: person.field3,
			field4: person.field4
		};

		if (person.addInfo3 == null) {
			data.field3 = id
		}

		if (person.addInfo4 == null) {
			data.field4 = id
		} else {
			data.field4 += `,${id}`;
		}

		utils.updatePersonFields(Object.keys(data), Object.values(data), () => {
			callback(id);
		})
	}

	function showMessage(form, modifier) {
		$(`.form-message${modifier}`, form).show();
	}

	function hideMessage(form, modifier) {
		$(`.form-message${modifier}`, form).hide();
	}

	function addOverlay() {
		overlay = overlay || $('.site-overlay');
		overlay.addClass('site-overlay_processing');
	}

	function removeOverlay() {
		overlay = overlay || $('.site-overlay');
		overlay.removeClass('site-overlay_processing');
	}

	$(() => {
		utils = Fw.component.models().utils;
	});

	Fw.component.export('locationsUtils', {
		createOrUpdateLocation,
		showMessage,
		hideMessage,
		addOverlay,
		removeOverlay,
		parseInfo
	});

	function init() {
		const form = $('.location-form-content');

		// Remove message when an input is changed
		$('input', form).change(() => {
			$('.form-message').hide();
		});
	}

	function escapeHistoryHtml(value) {
		if (value === null || value === undefined) return '';
		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	function formatHistoryDateParts(value) {
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) {
			return { date: '', time: '' };
		}

		return {
			date: new Intl.DateTimeFormat('en-CA', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			}).format(date),
			time: new Intl.DateTimeFormat('en-US', {
				hour: 'numeric',
				minute: '2-digit',
				second: '2-digit',
				hour12: true
			}).format(date)
		};
	}

	function renderLocationHistory(locationId, locationName) {
		if (!locationId || Number.parseInt(locationId, 10) <= 0) return;

		$.ajax({
			url: '/action/fetchTraceChanges',
			method: 'get',
			data: {
				type: 'location',
				recordId: locationId
			},
			dataType: 'json',
			success: function (response) {
				if (typeof response === 'string' && response.indexOf('error') != 0) {
					console.warn('no data available!');
					return;
				}

				const rows = Array.isArray(response) ? response : [response];
				const historyRows = rows && rows.length > 0 ? rows : [];
				const tableBody = $('.dataBody');

				$('#history-modal .table__thead').html(
					'<tr class="table__tr table__tr_head">' +
						'<th class="table__th h-0 p_1rem_1rem_2rem">Location</th>' +
						'<th class="table__th h-0 p_1rem_1rem_2rem">Date</th>' +
						'<th class="table__th h-0 p_1rem_1rem_2rem">Time</th>' +
						'<th class="table__th h-0 p_1rem_1rem_2rem">Who Did</th>' +
						'<th class="table__th h-0 p_1rem_1rem_2rem">What Did</th>' +
					'</tr>'
				);

				tableBody.html('');
				$('.modal-title').text('#' + locationId + ' Location History');

				for (var i = 0; i < historyRows.length; i++) {
					const parts = formatHistoryDateParts(historyRows[i].createdAt);
					tableBody.append(
						'<tr class="table__tr">' +
							'<td class="table__td h-0 p_p5rem_1rem">' + escapeHistoryHtml(locationName) + '</td>' +
							'<td class="table__td h-0 p_p5rem_1rem">' + escapeHistoryHtml(parts.date) + '</td>' +
							'<td class="table__td h-0 p_p5rem_1rem">' + escapeHistoryHtml(parts.time) + '</td>' +
							'<td class="table__td h-0 p_p5rem_1rem">' + escapeHistoryHtml(historyRows[i].createdByName || '') + '</td>' +
							'<td class="table__td h-0 p_p5rem_1rem">' + escapeHistoryHtml(historyRows[i].traceType || '') + '</td>' +
						'</tr>'
					);
				}

				if (historyRows.length === 0) {
					tableBody.html(
						'<tr class="table__tr">' +
							'<td class="table__td h-0 p_p5rem_1rem" colspan="5">No history available.</td>' +
						'</tr>'
					);
				}
			},
			error: function () {
				console.warn('no data available!');
			}
		});
	}

	$(document).on('click', '.locations-table .open-modal[modal-for="location-history"]', function () {
		renderLocationHistory($(this).attr('modal-data'), $(this).attr('modal-data2'));
	});

	// Iframe auto-resize listener — registered globally so it works
	// regardless of which tab is active when the script first loads.
	var IFRAME_IDS = ['buttonsTreeIframe', 'reportsIframe', 'contactDropdownIframe', 'calendarIframe', 'calendarDashboardIframe', 'ticketsIframe', 'instructionManualIframe', 'eulaIframe', 'formIframe'];
	var __lastIframeHeight = {};

	function sendParentViewToIframes() {
		for (var i = 0; i < IFRAME_IDS.length; i++) {
			var iframe = document.getElementById(IFRAME_IDS[i]);
			if (iframe && iframe.contentWindow) {
				try {
					var rect = iframe.getBoundingClientRect();
					iframe.contentWindow.postMessage({
						type: 'parent-view',
						iframeTop: rect.top,
						iframeLeft: rect.left,
						viewportHeight: window.innerHeight,
						viewportWidth: window.innerWidth
					}, '*');
				} catch (ex) { /* ignore */ }
			}
		}
	}

	var __parentViewRaf = 0;
	function scheduleParentView() {
		if (__parentViewRaf) return;
		__parentViewRaf = requestAnimationFrame(function () {
			__parentViewRaf = 0;
			sendParentViewToIframes();
		});
	}

	window.addEventListener('scroll', scheduleParentView, { passive: true });
	window.addEventListener('resize', scheduleParentView);

	window.addEventListener('message', function (e) {
		if (e.data && e.data.type === 'iframe-resize') {
			for (var i = 0; i < IFRAME_IDS.length; i++) {
				var iframe = document.getElementById(IFRAME_IDS[i]);
				if (iframe) {
					var prev = __lastIframeHeight[IFRAME_IDS[i]] || 0;
					if (Math.abs(e.data.height - prev) <= 4) continue;
					__lastIframeHeight[IFRAME_IDS[i]] = e.data.height;
					iframe.style.height = e.data.height + 'px';
					iframe.style.minHeight = e.data.height + 'px';
				}
			}
			scheduleParentView();
		}
		if (e.data && e.data.type === 'request-parent-view') {
			sendParentViewToIframes();
		}
		if (e.data && e.data.type === 'iframe-scroll-top') {
			for (var j = 0; j < IFRAME_IDS.length; j++) {
				var iframe2 = document.getElementById(IFRAME_IDS[j]);
				if (iframe2) {
					iframe2.scrollIntoView({ behavior: 'smooth', block: 'start' });
					break;
				}
			}
		}
	});

	// Contact Dropdown popup open/close
	$(document).on('click', '#open-contact-dropdown-popup', function () {
		$('#contact-dropdown-popup-overlay').fadeIn(200);
		// Re-trigger iframe content so it renders correctly after popup becomes visible
		var iframe = document.getElementById('contactDropdownIframe');
		if (iframe && iframe.src) {
			iframe.src = iframe.src;
		}
	});
	$(document).on('click', '#close-contact-dropdown-popup', function () {
		$('#contact-dropdown-popup-overlay').fadeOut(200);
	});
	$(document).on('click', '#contact-dropdown-popup-overlay', function (e) {
		if ($(e.target).is('#contact-dropdown-popup-overlay')) {
			$('#contact-dropdown-popup-overlay').fadeOut(200);
		}
	});

	$(init);

})(jQuery);